import type { ContactType } from '@/views/Contacts/shared/types';
import type { CoverSheetConfigCard } from '../../types';

/**
 * A cover sheet contact card. Only `id`, `entity` and `entityType` are read;
 * the fields, layout and validation live in the contacts engine.
 */
export const contactCard = (id: string, entityType: ContactType) =>
  ({
    id,
    entity: 'contacts',
    entityType,
    fields: {},
  }) satisfies CoverSheetConfigCard;
